import inventoryConsumables from './consumablesReducer';
import inventoryOrder from './inventoryOrderReducer';
import inventoryPricelists from './inventoryPricelistsReducer';
import inventory from './inventoryReducer';
import inventoryReturns from './inventoryReturnsReducer';
import inventoryServices from './inventoryServicesReducer';
import inventoryTransfers from './inventoryTransfersReducer';

export {
    inventoryConsumables, inventoryOrder, inventoryPricelists, inventory, inventoryReturns, inventoryServices, inventoryTransfers
};